import { Box } from '@mui/material'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useQueryClient } from 'react-query'

import HistorySmallIcon from '@hapana/shared/web/styles/assets/svgs/history-small.svg'
import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import {
  CLOSE_TYPES,
  SIZES,
} from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import Loading from '@hapana/shared/web/components/shared/loading/loading.component'
import Tabs from '@hapana/shared/web/components/shared/tabs/horizontal-tabs/tabs.component'
import { useSiteEnableTanningFeatures } from '_hooks/sites.hooks'
import { getEquipmentQueueClients } from '_services/tanning/equipment-queue.service'

import { TABS } from './modal-check-in.constants'
import { styles } from './modal-check-in.styles'
import CheckInTab from './modal-check-in-tabs/check-in-tab/check-in-tab.component'
import History from './modal-check-in-tabs/history/history.component'

const WAITLINE_TAB_VALUE = '2'

const ModalCheckIn = ({ defaultTab }) => {
  const { t } = useTranslation(['checkIn'])
  const { closeDialog, pushDialog, dialogState, setDialogState } = useDialog()
  const { data: siteEnableTanningFeatures, isLoading: isLoadingTanningFeatures } =
    useSiteEnableTanningFeatures()
  const queryClient = useQueryClient()

  const handleCloseCheckInModal = () => {
    closeDialog()
  }

  const handleTabChange = useCallback(
    (newTab) => {
      if (newTab === WAITLINE_TAB_VALUE) {
        queryClient.invalidateQueries(getEquipmentQueueClients.key)
      }
    },
    [queryClient]
  )

  const hasTanningFeatures = siteEnableTanningFeatures?.adminConfigurations?.enableTanningFeatures

  useEffect(() => {
    if (dialogState?.defaultTab) {
      setDialogState({ defaultTab: undefined })
    }
  }, [dialogState?.defaultTab, setDialogState])

  if (isLoadingTanningFeatures) {
    return (
      <DialogLayout
        closeType={CLOSE_TYPES.ICON}
        closeAction={handleCloseCheckInModal}
        title={t('checkIn:checkIn')}
        size={SIZES.SM}
      >
        <Box sx={styles.loadingContainer}>
          <Loading />
        </Box>
      </DialogLayout>
    )
  }

  return (
    <DialogLayout
      closeType={CLOSE_TYPES.ICON}
      closeAction={handleCloseCheckInModal}
      title={t('checkIn:checkIn')}
      size={SIZES.SM}
    >
      {hasTanningFeatures ? (
        <Tabs
          tabs={TABS}
          defaultValue={dialogState?.defaultTab || defaultTab}
          customStyles={styles.tabs}
          setTabValue={handleTabChange}
          buttons={[
            {
              icon: HistorySmallIcon,
              action: () => pushDialog(History, { title: t('checkIn:equipments.history.title') }),
              key: 'history',
            },
          ]}
        />
      ) : (
        <CheckInTab />
      )}
    </DialogLayout>
  )
}
export default ModalCheckIn

ModalCheckIn.propTypes = {
  defaultTab: PropTypes.string,
}

ModalCheckIn.defaultProps = {
  defaultTab: '1',
}
